import { useEffect, useRef } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Badge } from "@/components/ui/badge";
import { Clock, Users, Sparkles, Gift } from "lucide-react";
interface WaitlistIncentiveWidgetProps {
  className?: string;
}
const WaitlistIncentiveWidget = ({
  className
}: WaitlistIncentiveWidgetProps) => {
  const {
    language
  } = useLanguage();
  const iframeRef = useRef<HTMLDivElement>(null);
  const content = {
    fr: {
      title: "Rejoignez notre liste d'attente",
      subtitle: "Soyez les premiers informés du lancement",
      limited: "Accès prioritaire",
      remaining: "Places restantes",
      exclusive: "Avantages exclusifs"
    },
    en: {
      title: "Join our waitlist",
      subtitle: "Be the first to know about the launch",
      limited: "Priority access",
      remaining: "Spots remaining",
      exclusive: "Exclusive benefits"
    },
    de: {
      title: "Treten Sie unserer Warteliste bei",
      subtitle: "Seien Sie die ersten, die über den Launch informiert werden",
      limited: "Prioritärer Zugang",
      remaining: "Verbleibende Plätze",
      exclusive: "Exklusive Vorteile"
    }
  };
  useEffect(() => {
    // Load Tally widget
    if (window.Tally && iframeRef.current) {
      window.Tally.loadEmbeds();
    }
  }, []);
  return <div className={`relative bg-white/90 backdrop-blur-sm p-8 md:p-10 rounded-3xl shadow-2xl border border-gray-100 max-w-xl mx-auto overflow-hidden ${className}`}>
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-legatia-orange/10 to-legatia-yellow/10 rounded-full -translate-y-16 translate-x-16"></div>
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-legatia-yellow/10 to-legatia-green/10 rounded-full translate-y-12 -translate-x-12"></div>
      
      <div className="relative z-10">
        <div className="flex justify-between items-start mb-6">
          <div className="space-y-2">
            
            
          </div>
          
        </div>
        
        <p className="text-gray-600 mb-8 flex items-center gap-3 text-lg">
          <div className="w-10 h-10 bg-legatia-orange/10 rounded-full flex items-center justify-center">
            <Users className="h-5 w-5 text-legatia-orange" />
          </div>
          <span className="font-medium">{content[language].subtitle}</span>
        </p>
        
        
        
        <div ref={iframeRef} className="relative">
          <div className="absolute inset-0 bg-gradient-to-r from-legatia-light/20 to-transparent rounded-xl"></div>
          <iframe data-tally-src="https://tally.so/embed/mKOBJg?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1" loading="lazy" width="100%" height="120" frameBorder="0" marginHeight={0} marginWidth={0} title="Legatia arrive bientôt !" className="relative z-10 rounded-xl"></iframe>
        </div>
      </div>
    </div>;
};
export default WaitlistIncentiveWidget;